import { navigateTo } from '../http/redirect';
import Logger from '../logging/logger';
import { scrollWindow } from '../scroll.ts';
import { parseBool } from '../strconv/boolean';
import { getPagePopupContainer } from './page-popup';
import { anyPopupOpen, closeAllUtilityPopups, closeConfirmationPopup, confirmationPopupOpen, getOpenUtilityPopup, utilityPopupOpen } from './utils';

function handleKeyboardEvent( event: KeyboardEvent ): void {
    if ( event.key !== 'Escape' || !anyPopupOpen() ) {
        return;
    }

    if ( utilityPopupOpen() ) {
        handleUtilityPopupClose( event );
        return;
    }

    handlePagePopupClose();
}

function handleMouseEvent( event: PointerEvent ): void {
    if ( !event.target || !anyPopupOpen() ) {
        return;
    }

    const target = event.target as HTMLElement;

    const openPopup = getOpenUtilityPopup();

    if ( openPopup && parseBool( openPopup.dataset.preventBgClose || 'false' ) ) {
        Logger.info( 'background popup close prevented' );
        return;
    }

    if ( openPopup !== null && target.matches( '.popup__wrapper' ) ) {
        handleUtilityPopupClose( event );
        return;
    }

    if ( !target.matches( '.pagepopup__scrollcontainer' ) && !target.matches( '.pagepopup__wrapper' ) ) {
        return;
    }

    handlePagePopupClose();
}

function handlePagePopupClose(): void {
    const pagePopupContainer = getPagePopupContainer();

    if ( pagePopupContainer.classList.contains( 'pagepopup__wrapper--loading' ) ) {
        return;
    }

    const closeButton = pagePopupContainer.querySelector( '.pagepopup__close' ) as HTMLElement;

    if ( !closeButton ) {
        throw new Error( 'failed to find page popup close button' );
    }

    const href = closeButton.getAttribute( 'href' );

    if ( href !== null && href.length > 0 ) {
        navigateTo( href );
        return;
    }

    const routeAction = closeButton.dataset.action;

    if ( !routeAction ) {
        throw new Error( `no router action found on the close button, html=${closeButton.outerHTML}` );
    }

    closeButton.dispatchEvent( new CustomEvent( 'twc:manual-navigation', {
        bubbles: true,
    } ) );
}

function handleUtilityPopupClose( event?: Event ): void {
    closeAllUtilityPopups();
}

function handleConfirmationPopupClose( event?: Event ): void {
    closeConfirmationPopup();
}

function initPopupAltCloseMethods(): void {
    document.addEventListener( 'keydown', handleKeyboardEvent );
    document.addEventListener( 'click', handleMouseEvent );

    document.addEventListener( 'click', ( event: PointerEvent ) => {
        if ( !event.target || !( event.target instanceof HTMLElement ) ) {
            return;
        }

        if ( !event.target.matches( '[data-action="popup-close"]' ) ) {
            return;
        }

        const btn = event.target as HTMLButtonElement;

        if ( anyPopupOpen() ) {
            handleUtilityPopupClose( event );
        } else if ( confirmationPopupOpen() ) {
            handleConfirmationPopupClose( event );
        }

        if ( btn.dataset.resetScroll && btn.dataset.resetScroll === 'true' ) {
            scrollWindow( {
                top: 0,
                behavior: 'smooth',
            } );
        }
    } );
}

export { initPopupAltCloseMethods, handlePagePopupClose };
